/** @format */

import { Container, Row } from "react-bootstrap";
import Profile from "./emp-profile";
import background from "src/assets/images/9926.jpg";

const EmpProfile = () => {
  return (
    <>
      <div
        id="content-page"
        className="content-inner"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container className="mt-2 pb-5">
          <Row className="justify-content-center">
            <div className="bg-white p-4 rounded shadow-sm">
              <Profile />
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default EmpProfile;
